
import { BASE_URL } from "../constants/constants"

/**
 * Преобразует относительный URL в полный URL с текущим доменом
 * @param {string|null} url - URL для обработки
 * @returns {string|null} - Полный URL или null, если url не передан
 */
export const getFullUrl = (url) => {
  if (!url) return null

  // Если URL уже полный (начинается с http:// или https://), возвращаем как есть
  if (url.startsWith("http://") || url.startsWith("https://")) {
    return url
  }

  // Добавляем текущий домен к относительному URL
  const currentDomain = window.location.origin
  return `${currentDomain}${url.startsWith("/") ? url : `/${url}`}`
}

export function getUri(folder, fileType, type, name, rarity) {
  return `${BASE_URL}/assets/${folder}/${toCamelCase(type)}s/${toCamelCase(name)}/${toCamelCase(name)}${rarity}.${fileType}`
}

function toCamelCase(str) {
  str = str.charAt(0).toLowerCase() + str.slice(1)
  return str
    .trim()
    .replace(/[-_\s]+(.)?/g, (_, chr) => (chr ? chr.toUpperCase() : ""))
}
